import { InputGroup, RatingButtons, Text } from "@smartsuite/react-ui/lib";
import type { RatingDisplayFormat } from "@smartsuite/types";
import type { FC } from "react";
import * as yup from "yup";
import { FormFieldControl } from "../../../../components/FormFieldControl/FormFieldControl";
import { useFormField } from "../../../../hooks/useFormField";
import type { FormFieldProps } from "../../../types";
import { applyYupDefaults, validateWithYup } from "../../../validator";
import "./RatingFieldControl.sass";

export const RatingFieldControl: FC<FormFieldProps> = ({
  field,
  formItem,
  name,
  label,
  required,
  caption,
  readOnly,
}) => {
  const formField = useFormField<number>({
    name,
    validate: validateWithYup(applyYupDefaults(yup.string(), field, formItem)),
  });

  const handleChange = (value: number): void => {
    if (value === formField.value) {
      formField.onChange(null);
      return;
    }
    formField.onChange(value);
  };

  return (
    <FormFieldControl
      captionAsTooltip={formItem.params.help_text_as_tooltip}
      label={label}
      caption={caption}
      helpText={formItem.params.helpText}
      required={required}
      state={formField.state}
      errorMessage={formField.errorMessage}
      readOnly={readOnly}
    >
      <InputGroup className="rating-field" inputBackground="white-new">
        {field.params.include_labels && (
          <Text size="xs" wrapMode="ellipsis" className="rating-field__label">
            {field.params.rating_lowest}
          </Text>
        )}
        <RatingButtons
          displayFormat={(field.params.display_format as RatingDisplayFormat) ?? "stars"}
          value={formField.value}
          maxRate={field.params.scale ?? 5}
          disableTooltip={false}
          color={field.params.color ?? "#FDA80D"}
          onChangeValue={handleChange}
        />
        {field.params.include_labels && (
          <Text size="xs" wrapMode="ellipsis" className="rating-field__label">
            {field.params.rating_highest}
          </Text>
        )}
      </InputGroup>
    </FormFieldControl>
  );
};
